export const State = {
  hideNavigate: false,
  colorType: ''
}

export const Mutations = {
  hideNavigate(state, data) {
    state.hideNavigate = data
  },
  colorType(state, data) {
    state.colorType = data
  }
}

export const Actions = {
  hideNavigate({ commit }, data) {
    sessionStorage.hideNavigate = 1
  },

  loadHideNavigate({ commit }) {
    let hideNavigate = false
    try {
      hideNavigate = !!sessionStorage.hideNavigate
    } catch (e) { }
    commit('hideNavigate', hideNavigate)
  },
  colorType({ commit }, data) {
    sessionStorage.colorType = data
  },

  loadColorType({ commit }) {
    let colorType = 'default'
    try {
      colorType = sessionStorage.colorType
    } catch (e) { }
    commit('colorType', colorType)
  }
}
